import {
    WebCoreIoCKeys,
    IEventHandler,
    INotificationService,
    IoCContainer,
    ITranslation,
    IUtils,
    IWebCoreIoCContainer,
    IWebsiteConstants,
} from '@lmnop/web-core';

export class CoreModulesIoC {
    constructor() {
        let webCoreIoC: IWebCoreIoCContainer = IoCContainer.get(
            WebCoreIoCKeys.IWebCoreIoCContainer
        );
        this.notificationService = webCoreIoC.notificationService;
        this.translation = webCoreIoC.translation;
        this.utils = webCoreIoC.utils;
        this.eventHandler = webCoreIoC.eventHandler;
        this.websiteConstants = webCoreIoC.websiteConstants;
    }

    public translation: ITranslation;
    public notificationService: INotificationService;
    public utils: IUtils;
    public eventHandler: IEventHandler;
    public websiteConstants: IWebsiteConstants;
}
